import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { ModalComponent } from "../../modal/modal.component";
import { FormControl, Validators } from "@angular/forms";

@Component({
  selector: "file-upload-comment-modal",
  templateUrl: "./file-upload-comment-modal.component.html",
  styleUrls: ["./file-upload-comment-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadCommentModalComponent
  extends ModalComponent<{
    comment: string;
    isTeacher: boolean;
  }>
  implements OnInit
{
  @Output() onConfirm = new EventEmitter<string>();

  message: FormControl<string> = new FormControl("", [
    Validators.required,
    Validators.maxLength(255),
  ]);

  ngOnInit(): void {
    if (this.data.comment) {
      this.message.setValue(this.data.comment);
      this.message.disable();
    }
  }

  cancel(): void {
    this.onConfirm.emit("");
    this.close.emit("close");
  }

  confirm(): void {
    this.onConfirm.emit(this.message.value);
    this.close.emit("close");
  }
}
